import { IconButton } from "@mui/material";
import React from "react";
import { useAppContext } from "context";
import { Button } from "../../../controls";
import { CloseRounded, EditRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserCheckInOut from "./UserCheckInOut";
import ProfileDetails from "./ProfileDetails";
import SalesCounts from "./SalesCounts";
import UserAction from "./UserAction";

const Profile = ({ setOpen, open }) => {
  const { authUser } = useAppContext();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditProfile = () => {
    navigate(`/edit_my_account/${authUser.id}`);
    handleClose();
  };

  return (
    <div className="w-full h-full flex flex-col justify-between ">
      <div>
        <div className="flex justify-between text-right p-[5px] border-b mb-[15px]">
          <div>
            <IconButton size="small" onClick={handleClose}>
              <CloseRounded className="!text-[18px]" />
            </IconButton>
          </div>
          <div>
            <Button
              onClick={handleEditProfile}
              size="small"
              variant="text"
              startIcon={<EditRounded className="!text-[14px]" />}
            >
              {t("editProfile")}
            </Button>
          </div>
        </div>
        {/* Profile Details */}
        <ProfileDetails {...{ authUser }} />
        {/* Checkin and Checkout  */}
        <UserCheckInOut {...{ open }} />
        {/* Sale  */}
        <SalesCounts {...{ open }} />
      </div>
      {/* User Action */}
      <UserAction />
    </div>
  );
};

export default Profile;
